export default "__VITE_ASSET__8O_jqjCs__"